import React from "react";
import styled from "@emotion/styled";
import { Button } from "../Button";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  width: 75%;
  max-width: 546px;
  margin: 40px 0;
`;

interface LoadMoreButtonProps {
  numberOfProjects: number;
  numberOfVisibleProjects: number;
  numberOfVisiblePages: number;
  setNumberOfVisiblePages: (number: number) => void;
}

export const LoadMoreButton = ({
  numberOfProjects,
  numberOfVisibleProjects,
  numberOfVisiblePages,
  setNumberOfVisiblePages,
}: LoadMoreButtonProps) => {
  return (
    <Wrapper>
      {numberOfVisibleProjects < numberOfProjects ? (
        <StyledButton
          darkGreen
          text="Load more"
          onClick={() => {
            setNumberOfVisiblePages(numberOfVisiblePages + 1);
          }}
        />
      ) : (
        <StyledButton
          darkGreen
          text="Show less"
          onClick={() => {
            setNumberOfVisiblePages(numberOfVisiblePages - 1);
          }}
        />
      )}
    </Wrapper>
  );
};
